import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { authContext } from './store/adalConfig';
import { runWithAdal } from 'react-adal';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';  

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#2966aa',
            dark: '#283474'
        },
        secondary: {
            main: '#f44336',
        },
        action: {
            disabledBackground: '#bcbec0',
            disabled: "#fff"
        }
    },
    lpb: {
        resultBackgroundColors : {
            S: "#76c152",
            WD: "#f3723a",
            NB: "#283474",
            PI: "#db2b27"
        },
        body: {
            fontBlack75: "#636466",
            fontBlack30: "#bcbec0",
            fontWhite: "#ffffff"
        },
        header: {
            fontBlack90: "#414042",
            fontBlack5: "#f1f2f2",
            fontWhite: "#ffffff",
            fontBlack: "#000000"
        },
        borderColor: "#bcbec0"
    }   
});

const DO_NOT_LOGIN = true;

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

runWithAdal(authContext, () => {

    ReactDOM.render(
        <BrowserRouter basename={baseUrl}>
            <MuiThemeProvider theme={theme}>
                <App />
            </MuiThemeProvider>
        </BrowserRouter>,
        rootElement);

}, DO_NOT_LOGIN);
